// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"4d1f4cfd","605":"d9bada90","753":"17c21a8d","981":"cde62250"}[chunkId] + ".chunk.js";
};